/* ============
 * Education Modal Component
 * ============
 */
import mixin from "../../mixins/mixin";
import formService  from "../../services/form";
import defaultTemplateService from '../../services/default-template';
import bookingService from "../../services/booking";
import moment from "moment";

export default {
  data() {
    return {
      sendForm: {
        email: '',
        language: 'en'
      },
      templates: [],
      booking: {},
      guest: {},
      rental: {},
      invoice: {},
      payment: {},
      rentals: {},
      user: {},
      smallLoading: false,
    };
  },
  props: [
    'shortCodes',
    'invoiceSum',
    'bookingEvents',
  ],
  components: {
    VLoading : require('../loading/loading.vue')
  },
  mixins: [ mixin ],
  async mounted() {
    defaultTemplateService.get(this);
    if(this.$route.params.id) {
      await bookingService.getById(this.$route.params.id, this);
    }
  },
  methods: {
    open_send_form_modal(booking, guest, form) {
      var vm = this;

      this.generate_form_data(booking, guest, form);

      vm.openModal('#send-form-modal');
    },

    generate_form_data(booking, guest, form) {
      let vm = this;
      if (guest) {
        let guestCountry = null;
        if (guest.country) {
          guestCountry = (guest.country).toLowerCase();
        }
        if (guestCountry && guestCountry === 'fr' || guestCountry === 'en' || guestCountry === 'es' || guestCountry === 'pt') {
          this.sendForm.language = guestCountry;
        }
      }
      let template = this.templates.filter(function (t) {
          return t.name === 'Send form' && t.lang === vm.sendForm.language;
      })[0];

      let price =  booking.price + booking.cleaning + booking.price_extra;
      let link = window.location.protocol + "//" + 'superhote.com' + "/applink/booking/"+ booking.permalink + "/" + form.type.name;
      let checking = vm.booking.checking.replace('-', '').replace('-', '').toString();
      let checkout = vm.booking.checkout.replace('-', '').replace('-', '').toString();
      vm.sendForm.email = guest.email;
      vm.sendForm.subject = vm.generateMessage(template.subject, booking, checking, checkout, link, price);
      vm.sendForm.message = vm.generateMessage(template.context, booking, checking, checkout, link, price);
      vm.sendForm.bookingId = booking.id;
      vm.sendForm.form = form;
    },
    send_form (sendForm) {
      this.smallLoading = true;
      formService.sendForm(sendForm, this);
    },
    generateMessage(message, booking, checking, checkout, link, price) {
      let vm = this;
      let content = message.replace(/\[BOOKING:ID]+/g, booking.id)
        .replace(/\[BOOKING:RES-ID]+/g, booking.booking_com_res_id ? booking.booking_com_res_id : '-')
        .replace(/\[BOOKING:CONFIRMATION-CODE]+/g, booking.confirmation_code ? booking.confirmation_code : '-')
        .replace(/\[RENTAL:NAME]+/g, booking.rental.name)
        .replace(/\[RENTAL:HOSTFIRSTNAME]+/g, booking.rental.owner_first_name)
        .replace(/\[RENTAL:HOSTLASTNAME]+/g, booking.rental.owner_last_name)
        .replace(/\[BOOKING:CHECKING]+/g, moment(booking.checking, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        .replace(/\[BOOKING:CHECKOUT]+/g, moment(booking.checkout, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        .replace(/\[BOOKING:PLATFORM]+/g, booking.channel && booking.channel.name ? booking.channel.name : 'Direct')
        .replace(/\[BOOKING:CLEANINGVIDEO]+/g, vm.booking ? vm.getBookingCleaningVideoLink(this.bookingEvents) : '')
        .replace(/\[CHECKING:DD-MM-YYYY]+/g, moment(booking.checking, 'YYYY-MM-DD').format('DD-MM-YYYY'))
        .replace(/\[CHECKOUT:DD-MM-YYYY]+/g, moment(booking.checkout, 'YYYY-MM-DD').format('DD-MM-YYYY'))
        .replace(/\[BOOKING:ADULTS]+/g, booking.nbr_adults)
        .replace(/\[BOOKING:PRICE]+/g, price)
        .replace(/\[PRICE]+/g, price)
        .replace(/\[BOOKING:LINK]+/g, link)
        .replace(/\[FORM:LINK]+/g, link)
        .replace(/\[WELCOME_FORM_URL]+/g, window.location.protocol + "//" + 'superhote.com' + '/applink/booking/' + vm.booking.permalink + '/welcome')
        .replace(/\[CHECKIN_FORM_URL]+/g, window.location.protocol + "//" + 'superhote.com' + '/applink/booking/' + vm.booking.permalink + '/checkin')
        .replace(/\[RENTAL:EMAIL]+/g, vm.rental.email ? vm.rental.email : '-')
        .replace(/\[RENTAL:PHONE]+/g, vm.user.phone)
        .replace(/\[RENTAL:ADDRESS]+/g, vm.rental.address ? vm.rental.address : '-')
        .replace(/\[RENTAL:CITY]+/g, vm.rental.city ? vm.rental.city : '-')
        .replace(/\[RENTAL:COUNTRY]+/g, vm.rental.country ? vm.rental.country.name : '-')
        .replace(/\[RENTAL:ARRIVAL_TIME]+/g, vm.rental.checkin ? vm.rental.checkin : '-')
        .replace(/\[RENTAL:DEPARTURE_TIME]+/g, vm.rental.checkout ? vm.rental.checkout : '-')
        .replace(/\[INQUIRY:ARRIVE]+/g, vm.booking.time_in ? vm.booking.time_in : '-')
        .replace(/\[INQUIRY:DEPART]+/g, vm.booking.time_out ? vm.booking.time_in : '-')
        .replace(/\[INQUIRY:COST]+/g, vm.invoiceSum ? vm.invoiceSum : '')
        .replace(/\[INQUIRY:PRICE]+/g, vm.booking.price)
        .replace(/\[INQUIRY:NIGHTS]+/g, checkout - checking)
        .replace(/\[INQUIRY:ADULTS]+/g, vm.booking.nbr_adults)
        .replace(/\[INQUIRY:CHILDREN]+/g, vm.booking.nbr_children)
        .replace(/\[INQUIRY:BOOK_DATE]+/g, vm.booking.created_at)
        .replace(/\[CONTRACT:LINK]+/g, window.location.protocol + "//" + 'superhote.com' + '/applink/booking/' + vm.booking.permalink + '/contract')
        .replace(/\[INVOICE:LINK]+/g, window.location.protocol + "//" + 'superhote.com' + '/applink/invoice/' + vm.booking.permalink)
        .replace(/\[GUEST:NAME]+/g, vm.guest.first_name + ' ' + vm.guest.last_name)
        .replace(/\[GUEST:FIRST_NAME]+/g, vm.guest.first_name)
        .replace(/\[GUEST:LAST_NAME]+/g, vm.guest.last_name)
        .replace(/\[GUEST:EMAIL]+/g, vm.guest.email)
        .replace(/\[GUEST:PHONE]+/g, vm.guest.phone)
        .replace(/\[GUEST:CITY]+/g, vm.guest.city)
        .replace(/\[GUEST:COUNTRY]+/g, vm.guest.country)
        .replace(/\[GUEST:ADDRESS]+/g, vm.guest.address ? vm.guest.address : '')
        .replace(/\[PAYMENT:LINK]+/g, '-')
        .replace(/\[PAYMENT:TITLE]+/g, vm.payment.title ? vm.payment.title : '-')
        .replace(/\[PAYMENT:DESCRIPTION]+/g, vm.payment.description ? vm.payment.description : '-');
      return this.replaceCustomShortCodes(content, vm.booking.rental_id);
    },
    getTemplateByLang(lang) {
      let template = this.templates.find(t => {
        return t.name === 'Send form' && t.lang === lang;
      });
      let booking = this.booking;
      let form = this.sendForm.form;
      let price =  booking.price + booking.cleaning + booking.price_extra;
      let link = window.location.protocol + "//" + 'superhote.com' + "/applink/booking/"+ booking.permalink + "/" + form.type.name;
      let checking = this.booking.checking.replace('-', '').replace('-', '').toString();
      let checkout = this.booking.checkout.replace('-', '').replace('-', '').toString();

      this.sendForm.subject = this.generateMessage(template.subject, booking, checking, checkout, link, price);
      this.sendForm.message = this.generateMessage(template.context, booking, checking, checkout, link, price);
      this.sendForm.bookingId = booking.id;
    }
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/send-form-modal/send-form-modal.js